module.exports = __webpack_public_path__ + "assets/img/EIOTFooterBg.7c325e5e.png";